import React, { Component } from 'react'
import { connect } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar';
import { bindActionCreators } from 'redux'
import { showAddNoteModal, addNotes } from '../../../actions/profile';
import Icon from '@material-ui/core/Icon'
import { DayPicker } from 'react-day-picker'
import styled from 'styled-components'
import Modal from "../../../../../components/modal";
const moment = require('moment')

const TextBox = styled.textarea`
  background: #f1f2f5;
  border: none;
  border-radius: 4px;
  outline: none;
  color: #5a5a5a;
  font-family: 'DM Sans', sans-serif;
  font-size: 1rem;
  font-weight: 300;
  margin-bottom: 16px;
  max-width: 300px;
  min-height: 330px;
  padding: 12px;
  transition: 0.2s ease border, 0.2s ease box-shadow;
  width: 100%;
`;

const Container = styled.div`
  h2 {
    font-size: 1.25rem;
  }
`;


class AddNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      note: '',
      reportDate: '',
      isSubmitting: false,
      response: '',
      showSnackbar: false,
      changingDate: false,
      created_at: null,
    }
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  handleChangeDate = () => {
    this.setState({changingDate: true})
  }

  handleStopChangingDate = () => {
    this.setState({changingDate: false})
  }

  handleDayClick = ( day, { selected } ) => {
    this.setState({ changingDate: false, created_at: moment(day).local().format('YYYY-MM-DD') });
  }

  handleRequestClose = () => {
      this.setState({ showSnackbar: false });
  }

  handleClose = () => {
    this.props.showAddNoteModal(false)
  }

  todayString() {
    const date = new Date()
    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)
    return year + '-' + month + '-' + day
  }

  handleSubmit = (e) => {
    this.setState({ isSubmitting: true })
    const effectiveCreatedAt = this.state.created_at === null ? this.todayString() : this.state.created_at
    this.props.addNotes(this.props.user.id, this.props.account.user.id, effectiveCreatedAt, this.props.user.name, this.state.note)
    .then(() => {
        this.setState({ showSnackbar: true, response: ' Note added successfully!' })
        this.props.setUpdateNotes(true)
        this.handleClose()
    }).catch((err) => {
      this.setState({ showSnackbar: true, response: 'There is already a note for that date!' })
    });
  }

  render() {
    const effectiveCreatedAt = this.state.created_at === null ? this.todayString() : this.state.created_at
    const reportDate = moment(effectiveCreatedAt).calendar(null, {
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      nextWeek: 'ddd MMM DD YYYY',
      lastDay: '[Yesterday]',
      lastWeek: 'ddd MMM DD YYYY',
      sameElse: 'ddd MMM DD YYYY'
    })
    const { datePickerWrapper, profileThumb } = styles

    return (
      <Modal
        title="Add Note"
        open={this.props.showModal}
        onClose={this.handleClose}
        submitLabel="Save"
        handleSubmit={this.handleSubmit}
      >
          {/* <IconButton onClick={this.handleClose} style={{position: 'absolute', top: '4px', right: '4px'}}><Icon style={{fontSize: '2rem'}}>close</Icon></IconButton> */}
          <div style={{marginBottom: '8px', alignSelf: 'flex-start'}}>
            <div className='table-head-wrapper'>
              {!!this.props.account.user.profilePic && (
                <div style={{...profileThumb, backgroundImage: `url(${this.props.account.user.profilePic})`}}></div>
              )}
              <div><span style={{fontWeight: 'bold'}}>{this.props.account.user.full_name}</span><br />{this.props.account.user.email_address}</div>
            </div>
            <div style={{margin: '6px 0'}}>
              Select date: <span style={{fontSize: '1.17em', cursor: 'pointer', borderRadius: '10px', background: '#f8f8f8', display: 'inline-block', marginLeft: '20px', padding: '10px 15px'}} onClick={this.handleChangeDate}>{reportDate} &nbsp; &nbsp; <Icon style={{verticalAlign: 'text-bottom'}}>expand_more</Icon></span>
            </div>
          </div>
          <div className='edit-note-container'>
            {this.state.changingDate &&
              <Container>
                <div style={datePickerWrapper}>
                  <DayPicker
                    selected={new Date(effectiveCreatedAt + ' 00:00:00')}
                    defaultMonth={new Date(effectiveCreatedAt + ' 00:00:00')}
                    modifiersStyles={{selected: {backgroundColor: '#1fc44a'}}}
                    onDayClick={this.handleDayClick}
                  />
                </div>
              </Container>
            }
            <TextBox
              name='note'
              value={this.state.note}
              onChange={this.handleChange}
            />
          </div>
        <Snackbar className='snackbar' open={this.state.showSnackbar} message={this.state.response} autoHideDuration={3000} onClose={this.handleRequestClose}/>
      </Modal>
    )
  }
}


const styles = {
    profileThumb: {
      background: 'white',
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%',
      borderRadius: '50px',
      height: '80px',
      width: '80px',
      marginRight: '12px'
    },
    button: {
      yes: {
        background: '#eb0029',
        borderRadius: '3px',
        color: 'white',
        marginRight: 10,
        padding: '2px 15px',
      },
      no: {
        background: '#ddd',
        borderRadius: '3px',
        marginRight: 10,
        padding: '2px 15px',
      }
    },
    datePickerWrapper: {
      position: 'absolute',
      zIndex: '1',
      background: 'white',
      borderRadius: '5px',
      left: '50px'
    }
  }

function mapStateToProps(state) {
  return {
    showModal: state.user.showAddNoteModal,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showAddNoteModal, addNotes }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AddNotes)
